import React from 'react'
import { Button } from 'reactstrap'
import "./customButton.scss"

const CustomButton = (props) => {
  const {
    label,
    LabelIcon = null,
    iconPosition = "right",
    color = null,
    size = "btn-md",
    onClick = null,
    className,
    disabled,
    ukuran,
    iconColor = "",
    style
  } = props

  return (
    <Button
      className={className ? `${className} ${color} ${ukuran}` : `custom-button ${color} ${size}`}
      onClick={onClick}
      disabled={disabled}
      style={style}
    >
      {/* {console.log(props)} */}
      {/* {LabelIcon && <LabelIcon />}{label} */}
      {LabelIcon ? iconPosition === "left" ? <><LabelIcon style={{ stroke: iconColor }} />&nbsp;&nbsp;{label}</> : <>{label}&nbsp;&nbsp;<LabelIcon style={{ stroke: iconColor }} /></> : label}
    </Button>
  )
}

export default CustomButton